import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MagnifyingGlassIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import ServerTable from "../../components/atoms/tables/serverTable";
import Search from "../../components/select/Search";
import Loader from "../../components/atoms/loader";
import Axios from "../../AxiosConfig";
import { useStore } from "../../store";
const Leaves = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { layoutStore } = useStore();
    const columns = [
        {
            name: "Name",
            cell: (row) => (
                <a
                    href={`/employees/${row.user}`}
                    target="_blank"
                    className="text-blue-600 hover:text-blue-900 hover:underline"
                    rel="noreferrer"
                >
                    {row.name} <ArrowTopRightOnSquareIcon className="inline w-4 h-4" />
                </a>

            )
        },
        {
            name: "Designation",
            selector: "designation",
        },
        {
            name: "Department",
            selector: "department",
        },
        {
            name: "Reason",
            selector: "reason",
            sortable: true,
            sortField: "reason",
        },
        {
            name: "Start Date",
            selector: "startDate",
            sortable: true,
            cell: (row) => (
                <span>{new Date(row.startDate).toLocaleDateString()}</span>
            )
        },
        {
            name: "End Date",
            selector: "endDate",
            sortable: true,
            cell: (row) => (
                <span>{new Date(row.endDate ? row.endDate : row.startDate).toLocaleDateString()}</span>
            )
        },
        {
            name: "Status",
            selector: "status",
            cell: (row) => (
                <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium 
                 ${row.status === "Pending" ? "bg-yellow-100 text-yellow-800" : row.status === "Approved" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}
                `}>
                    {row.status}
                </span>
            )
        },
        {
            name: "Actions",
            cell: (row) => (
                <button
                    type="button"
                    onClick={() => navigate(`/leaves/${row.uuid}`)}
                    className="inline-flex items-center rounded border border-gray-300 bg-white px-5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    View
                </button>
            )
        }
    ]
    const [query, setQuery] = useState("");
    const [filters, setFilters] = useState({});
    const [status, setStatus] = useState("Pending");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [employee, setEmployee] = useState(null);
    const [loading, setLoading] = useState(false);
    const [reportUrl, setReportUrl] = useState(null);
    const today = new Date();
    var min_year = (today.getFullYear() - 10).toString();
    var max_year = (today.getFullYear() + 1).toString();
    var now_month = today.getMonth() + 1;
    if (now_month < 10){
        now_month = "0" + now_month.toString()
    }
    else{
        now_month =  now_month.toString()
    }
    var now_date = today.getDate()
    if (now_date < 10){
        now_date = "0" + now_date.toString()
    }
    else{
        now_date = now_date.toString()
    }
    const downloadReport = () => {
        setLoading(true);
        Axios.post("/reports/leaves", { filters }).then((res) => {
            if (res.data.success) {
                setReportUrl(res.data.url);
                window.open(res.data.url, "_blank");
            }
            else {
                layoutStore.showToaster(res.data.error, "error")
            }
            setLoading(false);
        });

    };
    useEffect(() => {
        let _filters = {};
        if (searchParams.get("status") != null) {
            setStatus(searchParams.get("status"));
        }
        if (query.length > 0) {
            _filters.query = query;
        }
        if (status !== "All") {
            _filters.status = status;
        }
        if (employee) {
            _filters.employee = employee.uuid;
        }
        if (startDate) {
            _filters.startDate = startDate;
        }
        if (endDate) {
            _filters.endDate = endDate;
        }
        setFilters(_filters);
        setReportUrl(null);
    }, [query, status, employee, startDate, endDate]);
    return (
        <>
            {loading && <Loader />}
            {
                reportUrl &&
                <div className="rounded-md bg-blue-50 p-4 mb-4">
                    <div className="flex">
                        <div className="ml-3 flex-1 md:flex md:justify-between">
                            <p className="text-sm text-blue-700">
                                If the download didn't start automatically, download the report by clicking the link 👉.
                            </p>
                            <p className="mt-3 text-sm md:mt-0 md:ml-6">
                                <a href={reportUrl}
                                    target="_blank"
                                    className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600"
                                    rel="noreferrer">
                                    Download Report
                                    <span aria-hidden="true"> &rarr;</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            }
            <div className="mt-1 flex rounded-md shadow-sm">
                <div className="grow mr-px search_by_employee border border-0.5 border-gray-300 hover:border-blue-500 rounded-l-md">
                    <Search
                        apiURL="/employee/search"
                        setParent={setEmployee}
                        placeholder="Search By Employee"
                    />
                </div>
                <div className="mx-px">
                    <select
                        onChange={(e) => setStatus(e.target.value)}
                        defaultValue={status || "" }
                        value={status}
                        className="w-full h-full border border-0.5 border-gray-300 py-2 pl-3 pr-10 text-base hover:border-blue-500 focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm">
                        <option value={"All"}>All</option>
                        <option value={"Pending"}>Pending</option>
                        <option value={"Approved"}>Approved</option>
                        <option value={"Denied"}>Denied</option>
                        <option value={"Retracted"}>Retracted</option>
                    </select>
                </div>
                <span className="isolate inline-flex rounded-md shadow-sm">
                    <button
                        type="button"
                        onClick={() => {
                            window.location.reload();
                        }}
                        disabled={Object.keys(filters).length === 1 && filters.status =="Pending"}
                        className="inline-flex items-center border-white bg-blue-600 mx-px px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Reset Filters
                    </button>
                </span>
                <span className="isolate inline-flex rounded-md shadow-sm">
                    <button
                        type="button"
                        onClick={downloadReport}
                        className="inline-flex items-center border-white bg-blue-600 mx-px px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Export Data
                    </button>
                </span>
                <span className="isolate inline-flex rounded-md shadow-sm">
                    <button
                        type="button"
                        onClick={() => navigate("/leaves/new")}
                        className="inline-flex items-center rounded-r-md border border-transparent bg-blue-600 ml-px px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Create Leave
                    </button>
                </span>
            </div>
            <div className="mt-3 flex rounded-md shadow-sm">
                <div className="relative flex flex-grow items-stretch focus-within:z-10">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                        type="search"
                        name="search"
                        onChange={(e) => setQuery(e.target.value)}
                        className={`block w-full rounded-md border-gray-300 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm hover:border-blue-500`}
                        placeholder="Search By Reason"
                        value={query}
                    />
                </div>

            </div>
            <div className="mt-2 rounded-md flex ">
                <div className="grow mr-px">
                    <label htmlFor="startDate" >
                        Start Date
                    </label>
                    <input
                        type="date"
                        name="startDate"
                        id="startDate"
                        min={min_year + '-' + now_month + '-' + now_date}
                        max={max_year + '-' + now_month + '-' + now_date}
                        value={startDate || ''}
                        onChange={(e) => {
                            // setStartDate(e.target.value)
                            if (e.target.value > max_year + '-' + now_month + '-' + now_date){
                                setStartDate(max_year + '-' + now_month + '-' + now_date)
                                setEndDate(max_year + '-' + now_month + '-' + now_date)
                            } else{
                                setStartDate(e.target.value)
                            }                            
                            if (new Date(e.target.value) > new Date(endDate) || !endDate) {
                                setEndDate(e.target.value)
                            }
                        }}
                        className="block w-full border border-0.5 border-gray-300 py-1.5 rounded-l-md text-gray-900 shadow-sm ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 hover:border-blue-500 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                    />
                </div>
                <div className="grow ml-px">
                    <label htmlFor="endDate" >
                        End Date
                    </label>
                    <input
                        type="date"
                        name="endDate"
                        id="endDate"
                        value={endDate || ''}
                        onChange={(e) => {
                            // if (new Date(e.target.value) < new Date(startDate) || !startDate) {
                            //     setStartDate(e.target.value)
                            // }
                            if (e.target.value > max_year + '-' + now_month + '-' + now_date) {
                                setEndDate(max_year + '-' + now_month + '-' + now_date)
                            } else{
                                setEndDate(e.target.value)
                            }
                            // setEndDate(e.target.value)
                        }}
                        className="block w-full border border-0.5 border-gray-300 py-1.5 rounded-r-md text-gray-900 shadow-sm ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 hover:border-blue-500 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                        min={startDate}
                        max={max_year + '-' + now_month + '-' + now_date}
                    />
                </div>
            </div>

            <div className='mt-4'>
                <ServerTable
                    key={JSON.stringify(filters)}
                    apiURL={'/working-days/leaves'}
                    columns={columns}
                    filters={filters}
                />
            </div>
        </>
    )
}
export default Leaves;